import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {observer} from 'mobx-react'
import Select from 'react-select/async'

const selectStyles = {
    valueContainer: (styles) => {
        styles.paddingLeft = '5px'

        return styles
    },
    indicatorSeparator: (styles) => ({
        display: 'none',
    }),
    option: (styles, {data}) => {
        styles.color = data && data.is_empty
            ? '#aaaaaa'
            : '#000000'

        return styles
    },
    group: (styles) => {
        styles.marginLeft = '10px'

        return styles
    },
    groupHeading: (styles) => {
        styles.marginLeft = '-10px'

        return styles
    },
}

const theme = theme => ({
    ...theme,
    borderRadius: 0,
    colors: {
        ...theme.colors,
        // primary: '#000',
        // neutral0: '#fff',
        neutral10: '#000',
        neutral20: '#000',
    },
    spacing: {
        ...theme.spacing,
        controlHeight: 26,
        menuGutter: 2,
        baseUnit: 1,
    },
})

@observer export default class DependentSearchableSelect extends Component {
    render() {
        const {state: _, ...props} = this.props
        const state = this.getFormState()

        return (
            <Select
                defaultOptions={[]}
                styles={selectStyles}
                theme={theme}
                {...props}
                isDisabled={state.inputs_are_disabled}
            />
        )
    }

    /**
     * @return {ProfileSettingsEditState}
     */
    getFormState = () => {
        return this.props.state
    }
}

DependentSearchableSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.any,
        value: PropTypes.any
    })),
    state: PropTypes.any.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.any,
    className: PropTypes.any,
}

